import { AiNameGeneratorWidgetContentfulModel } from 'src/api/models/AiNameGeneratorWidget';
import { palette } from 'app_previous/styles/colors';
import { ColorScheme } from 'app_previous/styles/functions/getButtonStyleByColorScheme';
import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

export interface Theme {
  background: string;
  divider: string;
  text: string;
  secondaryText: string;
  suggestionBackground: string;
  link: ColorScheme;
  buttonBackground: string;
  buttonBorderColor: string;
  formBackground: string;
}

export const InlineNameGeneratorThemesColors: Record<AiNameGeneratorWidgetContentfulModel['theme'], Theme> = {
  Default: {
    background: palette.solitudeFog,
    divider: palette.lightGrayBright,
    text: palette.greyText,
    secondaryText: palette.darkGray,
    suggestionBackground: 'rgba(255, 255, 255, 0.6)',
    link: 'AccentBlue',
    buttonBackground: palette.accentBlue,
    buttonBorderColor: palette.accentBlue,
    formBackground: palette.accentBlue,
  },
  'Purple Navy': {
    background: palette.newGreen,
    divider: palette.lightGrayBright,
    text: palette.white,
    secondaryText: palette.white,
    suggestionBackground: 'rgba(255, 255, 255, 0.15)',
    link: 'White',
    buttonBackground: palette.greyText,
    buttonBorderColor: palette.white,
    formBackground: palette.greyText,
  },
};

interface ThemeProps {
  themeKey: keyof typeof InlineNameGeneratorThemesColors;
}

export const InlineNameGeneratorContainer = styled.div`
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
`;

export const InlineNameGeneratorContent = styled.div<ThemeProps>`
  display: grid;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 4.375rem 2rem;
  background: ${(props) => InlineNameGeneratorThemesColors[props.themeKey].background};
  grid-row-gap: 1.7rem;

  #inline-generator {
    max-width: 635px;
  }

  @media (max-width: ${layout.md}) {
    grid-row-gap: 1.5rem;
    padding: 2rem 1.5rem;
  }
`;

export const SubheadContainer = styled.div`
  max-width: 750px;
  margin: 0 auto;
`;

export const Disclaimer = styled.div`
  width: 100%;
  max-width: 474px;
  display: grid;
  margin-top: 1.5rem;
  justify-self: center;

  a {
    color: inherit;
    text-decoration: underline;
  }

  @media (max-width: ${layout.md}) {
    margin-top: 0;
  }
`;
